import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

import history from '../utils/history';
import * as sinisterCardsActions from '../redux/actions/sinister-cards';
import * as http from '../utils/http';
import { checkIfHotjarEnable, capitalizeFirstLetter, dynaTraceGetAction, dynaTraceLeaveAction, timeBetweenDates, formatDateReverse } from '../utils/helpers';
import { coveragePlans } from '../data/coveragePlan';
import RimacTopBar from '../components/common/RimacTopBar/RimacTopBar';
import InfoCard from '../components/content/InfoCard/InfoCard';
import Modal from '../components/common/modal/Modal';
import RimacFooter from '../components/common/RimacFooter/RimacFooter';
import RimacTag from '../components/common/RimacTag/RimacTag';
import SplitLayout from '../layout/SplitLayout';
import IconEdit from '../assets/icon_edit_gray.svg';
import IconWarning from '../assets/icons/ic_warning_blue.svg';
import IconCheckGreen from '../assets/ic_check_green.svg';
import IconInfo from '../assets/icons/ic_info_blue.svg';
import { PAGINAS_BY_STEP } from '../utils/constants';
import { setErrorCode } from '../redux/actions/coverage';

const ValidateInfoPage = () => {
  const dispatch = useDispatch();
  const advisorInfo = useSelector( (state) => state.sinisterCards.advisorInfo)
  const userInfo = useSelector((state) => state.sinisterCards.userInfo);
  const accountInfo = useSelector((state) => state.sinisterCards.accountInfo);
  const currentCoveragePlan = useSelector(
    (state) => state.coverages.currentPlan
  );
  const currentUser = useSelector((state) => state.sinisterCards.userInfo);
  const currentUserName = `${capitalizeFirstLetter(
    currentUser?.name
  )} ${capitalizeFirstLetter(currentUser?.fatherLastName)}`;
  const sinisterList = useSelector((state) => state.sinisterCards.sinisterList);
  const sinisterFiles = useSelector(
    (state) => state.sinisterCards.sinisterFiles
  );
  const sinisterDate = useSelector((state) => state.sinisterCards.sinisterDate);
  const otherInsurance = useSelector(
    (state) => state.sinisterCards.otherInsurance
  );
  const isOtherSinisterSelected = sinisterList.some(
    (sinister) => sinister.code === 'OTRO_SINIESTRO'
  );
  const otherSinisterDescription = useSelector(
    (state) => state.sinisterCards.otherDescription
  );
  const [viewStartTime] = useState(new Date());
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [currentSinisterClick] = useState(null);
  const [loading, setLoading] = useState(false);
  const sinisterCOB03 = sinisterList.find((sin) => sin.code === 'COB03');
  const fileForCOB03 = sinisterFiles.find(
    (file) => file.typeFile === 'CARTA DEL BANCO'
  );

  if (sinisterCOB03 && !fileForCOB03) {
    sinisterFiles.push({
      title: 'Carta emitida por el banco BBVA',
      typeFile: 'CARTA DEL BANCO',
      id: '6',
      files: [],
    });
  }

  useEffect(() => {
    if (!viewStartTime) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    const endTime = new Date();
    const userTotalTime = timeBetweenDates(viewStartTime, endTime);

    if (checkIfHotjarEnable()) {
      // LAST
      window.digitalData.push({
        task: {
          name: 'Tiempo registrado - Resumen',
          time: userTotalTime,
        },
        event: 'trackTimeToComplete',
      });
    }
  }, [viewStartTime]);

  const onClickEditForm = (step) => {
    if (checkIfHotjarEnable()) {
      // LAST
      window.digitalData.push({
        "action": {
          "group": "Tramites Siniestros - Protección Tarjeta BBVA",
          "category": `Confirmación - ${capitalizeFirstLetter(currentCoveragePlan.toLowerCase())}`,
          "name": "Validar información",
          "label": `${step.seccionEditar} - Editar`
        },
        "event": 'trackAction'
      });
    }
    if (PAGINAS_BY_STEP.HOME.step === step.step) {
      history.replace(PAGINAS_BY_STEP.HOME.uri);
    } else {
      history.replace( `/${coveragePlans[currentCoveragePlan].uri}${step.uri}`);
    }
  };

  const onClickSinisterDelete = () => {
    const updatedList = sinisterList.filter(
      (sr) => sr.code !== currentSinisterClick
    );
    dispatch(sinisterCardsActions.updateSinisterList(updatedList));
    dispatch(sinisterCardsActions.setSinister(updatedList.length - 1));
    setOpenDeleteModal(false);
  };

  const onSendSinisterHandler = async () => {
    console.log('finishing...');

    setLoading(true);
    const action = dynaTraceGetAction('click send form button');
    const realDate = new Date(sinisterDate);
    const month = String(realDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(realDate.getUTCDate()).padStart(2, '0');
    const year = realDate.getUTCFullYear();
    const formatedDate = `${day}/${month}/${year}`;
    const subTipoDocumentos = [];
    sinisterFiles.forEach((sFile) => {
      sFile.files.forEach((file) => {
        subTipoDocumentos.push({
          tipo: sFile.typeFile,
          extension: String(file.name.split('.').pop()).toLowerCase(),
          content: file,
        });
      });
    });
    const subTipoDocumentosInfo = subTipoDocumentos.map((file) => {
      return {
        tipo: file['tipo'],
        extension: file['extension'],
      };
    });
    const name = userInfo.name
      .split(' ')
      .filter((el) => el !== '')
      .join(' ');
    const fatherLastName = userInfo.fatherLastName
      .split(' ')
      .filter((el) => el !== '')
      .join(' ');
    const motherLastName = userInfo.motherLastName
      .split(' ')
      .filter((el) => el !== '')
      .join(' ');
    const docPayload = {
      data: {
        aseguradoDetalle: {
          tipoDocumento: userInfo.documentType.value,
          numeroDocumento: userInfo.document,
          nombre: name,
          apellidoPaterno: fatherLastName,
          apellidoMaterno: motherLastName,
        },
        subTipoDocumentos: subTipoDocumentosInfo,
        fechaSiniestro: formatedDate,
      },
    };
    const sinisters = sinisterList.map((sinister) => {
      return {
        nombre: sinister.code,
        montoSoles: Number(sinister.soles),
        montoDolares: Number(sinister.dollars || 0),
      };
    });
    try {
      
      const docs = await http.post(
        '/documentos',
        docPayload,
        process.env.REACT_APP_API_NAME
      );
      const ideSiniestro = docs.payload.ideSiniestro;
      await Promise.all(
        docs.payload.documentos.map(async (el, i) => {
          let blob = await fetch(subTipoDocumentos[i].content.content).then(
            (r) => r.blob()
          );
          const newFile = new File([blob], subTipoDocumentos[i].content.name);
          await axios.put(el.url, newFile, {
            headers: {
              'Content-Type': subTipoDocumentos[i].content.type,
            },
          });
        })
      );
      const refundAccounts = accountInfo
        .filter((el) => el.cci !== '')
        .map((el) => {
          return {
            cciReembolso: el.cci,
            bancoReembolso: el.bank.payloadValue,
            tipoCuentaReembolso: el.accountType.value,
            moneda: el.currency,
          };
        });
      const proteccionTarjetasOtros =
        otherInsurance.otherInsurance === 'si' ? 'SI' : 'NO';
      const proteccionTarjetasCobertura =
        otherInsurance.coverage === 'si' ? 'SI' : 'NO';
      const sinisterPayload = {
        siniestro: {
          ideSiniestro: ideSiniestro,
          persona: {
            tipoDocumento: userInfo.documentType.value,
            numeroDocumento: userInfo.document,
            nombre: name,
            apellidoPaterno: fatherLastName,
            apellidoMaterno: motherLastName,
            departamento: userInfo.department.text,
            correo: userInfo.email,
            celular: userInfo.phone,
          },
          coberturas: sinisters,
          fechaSiniestro: formatedDate,
          cuentasReembolso: refundAccounts,
          proteccionTarjetasOTros: proteccionTarjetasOtros,
          solicitoCoberturaMismoSiniestro: proteccionTarjetasCobertura, 
        },
      };
      if (advisorInfo) {
        sinisterPayload.siniestro.asesor = {
          nombre: advisorInfo.text || '',
          email: advisorInfo.email || '',
          codigo: advisorInfo.value || '',
          fechaLlamada: formatDateReverse( advisorInfo.date || new Date() ),
        }
      }
      if (isOtherSinisterSelected) {
        sinisterPayload.siniestro.descripcionSiniestro = otherSinisterDescription;
      }
      const result = await http.post(
        '/siniestros',
        sinisterPayload,
        process.env.REACT_APP_API_NAME
      );
      if (result.payload.error) {
        history.replace('/new-error');
        return;
      }
      if (checkIfHotjarEnable()) {
        // LAST
        window.digitalData.push({
          event: 'trackRegisterSinisterBbvaCardProtection',
        });
        sinisterList.forEach((sinister) => {
          // LAST
          window.digitalData.push({
            metadata: {
              key: 'Tipo de siniestro - Protección Tarjeta BBVA',
              value: `${capitalizeFirstLetter(currentCoveragePlan.toLowerCase())} - ${sinister.title}`,
            },
            event: 'trackMetadata',
          });
        });
      }
      setLoading(false);
      dynaTraceLeaveAction(action);
      dispatch(sinisterCardsActions.resetState());
      dispatch(sinisterCardsActions.setStep(PAGINAS_BY_STEP.NEW_THANKYOU.step));
      history.replace(`/new-gracias?type=${result.payload.tipoPlantilla}`);
    } catch (err) {
      console.log(err);
      setLoading(false);
      dispatch(sinisterCardsActions.resetState());
      if (err.code === 'ERR_NETWORK' || [504].includes(err?.response?.status)) {
        dispatch(setErrorCode(504))
      }
      history.replace('/new-error');
    }
  };

  function replaceWithBr(texto) {
    return texto.replace(/\n/g, '<br />')
  }

  const leftContent = (
    <>
      <RimacTag
        customClasses="u-mb-8"
        color={coveragePlans[currentCoveragePlan].color}
        text={coveragePlans[currentCoveragePlan].name}
      />
      <div className="titleCont">
        <h1 className="u-mb-40">Seguro de Protección de Tarjetas</h1>
        <p>
          <span className="u-font-bold">{currentUserName}</span>, Estas reportando:
        </p>
        <ul className="rimacCardCont">
          {sinisterList.map((cov) => (
            <div key={cov.code} className="rimacLiteCard u-mb-8">
              <img
                className="rimacLiteCard__img"
                src={cov.icon}
                alt={cov.title}
              />
              <p className="rimacLiteCard__title">{cov.title}</p>
            </div>
          ))}
        </ul>
      </div>
    </>
  );

  const rightContent = (
    <>
      <RimacTag
        customClasses="u-mb-8 mobile"
        color={coveragePlans[currentCoveragePlan].color}
        text={coveragePlans[currentCoveragePlan].name}
      />
      <div className="titleCont">
        <h3>Validemos la información ingresada</h3>
      </div>

      <section className="coveragesCont--mobile u-mt-16">
        <p className="u-mb-24">Estas reportando: </p>
        {sinisterList.map((cov) => (
          <div key={cov.code} className="rimacLiteCard u-mb-20">
            <img
              className="rimacLiteCard__img"
              src={cov.icon}
              alt={cov.title}
            />
            <p className="rimacLiteCard__title">{cov.title}</p>
          </div>
        ))}
      </section>

      <section className="infoSection u-mb-40">
        <div className="infoSection__left">
          <h5 className="infoSection__title">Estos son los datos ingresados de tu reporte de siniestro:</h5>
          <div className="infoSection__content">
            <div className="info--column">
              <p className="info__title u-mb-8">Teléfono</p>
              <p className="u-pl-14">{userInfo.phone}</p>
            </div>
            <div className="info-column">
              <p className="info__title u-mb-8">Correo</p>
              <p className="u-pl-14">{userInfo.email}</p>
            </div>
          </div>
        </div>
        <div className="infoSection__right">
          <button className="iconBtn" onClick={() => onClickEditForm(PAGINAS_BY_STEP.HOME)}>
            <span className="iconBtn__icon">
              <img src={IconEdit} alt="icon" />
            </span>
            <p>EDITAR</p>
          </button>
        </div>
      </section>

      <section className="infoSection u-mb-40">
        <div className="infoSection__left">
          <h5 className="infoSection__title">Has cargado documentos en los siguientes campos:</h5>
          <ul className="infoSection__docList">
            {sinisterFiles.map((file) => (
              <li key={'file-list' + file.typeFile}>
                <img
                  src={file.files.length === 0 ? IconWarning : IconCheckGreen}
                  alt="icono check"
                />
                <span className="itemText">{file.title}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="infoSection__right">
          <button className="iconBtn" onClick={() => onClickEditForm(PAGINAS_BY_STEP.DOCUMENTOS_REQUERIDOS)}>
            <span className="iconBtn__icon">
              <img src={IconEdit} alt="icon" />
            </span>
            <p>EDITAR</p>
          </button>
        </div>
      </section>

      {isOtherSinisterSelected ? (
        <section className="infoSection u-mb-40">
          <div className="infoSection__left">
            <h5 className="infoSection__title">Descripción del siniestro</h5>
            <p className="infoSection__description" dangerouslySetInnerHTML={{__html: replaceWithBr(otherSinisterDescription)}}>
            </p>
          </div>
          <div className="infoSection__right">
            <button className="iconBtn" onClick={() => onClickEditForm(PAGINAS_BY_STEP.DESCRIPCION_OTRO_SINIESTRO)}>
              <span className="iconBtn__icon">
                <img src={IconEdit} alt="icon" />
              </span>
              <p>EDITAR</p>
            </button>
          </div>
        </section>
      ) : null}

      <section className="infoSection u-mb-40">
        <div className="infoSection__left">
          <h5 className="infoSection__title">Tus datos bancarios son:</h5>
          <div className="infoSection__content--column">
            {accountInfo.map((account, i) => {
              if (account.bank) {
                return (
                  <div
                    key={'bank-list' + i}
                    className={`info--column ${i === 0 ? 'u-mb-16' : ''}`}
                  >
                    <p className="info__title u-mb-8">
                      Banco {account.bank.text}
                    </p>
                    <p className="u-mb-10  u-pl-14">
                      {account.accountType.text}{' '}
                      {account.currency === 'PEN' ? 'soles' : 'dólares'}
                    </p>
                    <p className="u-pl-14">CCI: {account.cci}</p>
                  </div>
                );
              }
            })}
          </div>
        </div>
        <div className="infoSection__right">
          <button className="iconBtn" onClick={() => onClickEditForm(PAGINAS_BY_STEP.INFO_REEMBOLSO)}>
            <span className="iconBtn__icon">
              <img src={IconEdit} alt="icon" />
            </span>
            <p>EDITAR</p>
          </button>
        </div>
      </section>

      <section className="infoSection u-mb-40">
        <div className="infoSection__center">
          <div className="infoSection__titleCont">
            <h5 className="infoSection__title">
              Montos reportados del siniestro:
            </h5>
            <button className="iconBtn" onClick={() => onClickEditForm(PAGINAS_BY_STEP.MONTOS_ROBADOS)}>
              <span className="iconBtn__icon">
                <img src={IconEdit} alt="icon" />
              </span>
              <p>EDITAR</p>
            </button>
          </div>
          <ul className="infoSection__content">
            {sinisterList.map((sinister) => (
              <li key={'info_' + sinister.code} className="info u-w-100">
                <div className="info__left">
                  <p className="info__title">{sinister.title}</p>
                  {Number(sinister.soles) > 0 && (
                    <p>{`Soles: S/${sinister.soles}`}</p>
                  )}
                  {Number(sinister.dollars) > 0 && (
                    <p>{`Dólares: $${sinister.dollars}`}</p>
                  )}
                  <p className="info__gray">{sinister.amountInfo}</p>
                </div>
                <div className="info__right">
                  {sinister.warningTxt ? (
                    <div className="rimacTooltip">
                      <img
                        className="rimacTooltip__img"
                        src={IconInfo}
                        alt={sinister.title}
                      />
                      <span className="rimacTooltip__content">
                        {sinister.warningTxt}
                      </span>
                    </div>
                  ) : null}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <InfoCard
        icon={IconWarning}
        content={
          <p>
            <b>Al hacer clic en el botón "Finalizar" confirmas que </b>
            la información provista es cierta y tiene carácter de declaración
            jurada. Asimismo, estás aceptando la presentación de tu solicitud de
            siniestro a través de este formulario digital.
          </p>
        }
      />
    </>
  );

  return !loading ? (
    <SplitLayout
      containerClasses="validateInfoPage"
      leftClasses="validateInfoPage__left"
      rightClasses="validateInfoPage__right"
      leftContent={leftContent}
      rightContent={rightContent}
      isNavActive={false}
      onNavContinueClick={onSendSinisterHandler}
      isNavLoading={loading}
      navCurrentStep={5}
      navTotalSteps={5}
      navBtnText="Finalizar"
    >
      <Modal
        onLabelClosed={true}
        visible={openDeleteModal}
        onToggle={() => setOpenDeleteModal(false)}
        className={openDeleteModal ? 'remove-modal-main' : ''}
        onLabelTextClosed=""
      >
        <div className="remove-modal-main__info">
          <div className="remove-modal-main__info-container">
            <h1>¡Eliminar monto registrado!</h1>
            <hr />
            <div className="remove-modal-main__info-content">
              <p>
                ¿Estás seguro que deseas eliminar el monto registrado de tu
                lista?
              </p>
            </div>
          </div>
          <div className="remove-modal-main__info-actions">
            <div className="remove-modal-main__info-button">
              <button
                className="remove-modal-main__info-button--outlined"
                onClick={() => setOpenDeleteModal(false)}
              >
                No, cancelar
              </button>
            </div>
            <div className="remove-modal-main__info-button">
              <button
                className="remove-modal-main__info-button--base"
                onClick={onClickSinisterDelete}
              >
                SI, ELIMINAR
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </SplitLayout>
  ) : (
    <>
      <RimacTopBar />
        <div className="loadingPage">
          <section className="loadingPage__cont">
            <button
              className='rd--button'
            >
              <div className="rd--loader rd--loader2">
                <div className="rd--spinner rd--spinner2" />
              </div>
            </button>
            <h1 className="loadingPage__title">
              ¡Danos un momento!{' '}
            </h1>
            <div className='loadingPage__content'>
              Estamos procesando tu solicitud.
              <b> No cierres</b> esta ventana.
            </div>
          </section>
        </div>
        <RimacFooter isAppInfoActive={false} />
      </>
  );
};

export default ValidateInfoPage;
